// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Повторите попытку, используя дату завершения, например: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Группа',
  chart_labelSeries: () => 'Серия',
  chart_labelValue: () => 'Значение',
  checkboxSet_requiredMessageDetail: () => 'Обязательно',
  checkbox_requiredMessageDetail: () => 'Обязательно',
  close: () => 'Закрыть',
  collection_noData: () => 'Нет данных для отображения.',
  collection_selectAllRows: () => 'Выбрать все строки',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Выбрать строку ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Сортировка невозможна',
  collection_sortEnabled: () => 'Доступно для сортировки',
  confirmation: () => 'Подтверждение',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' из ' + p['totalCount'],
  dataVisualization_noData: () => 'Нет данных для отображения',
  dataVisualization_stateSelected: () => 'Выбрано',
  dataVisualization_stateUnselected: () => 'Не выбрано',
  error: () => 'Ошибка',
  expandableList_expandCollapseInstructionText: () =>
    'Для развертывания и свертывания используйте клавиши со стрелками',
  expandableList_groupCollapse: () => 'Свернуто',
  expandableList_groupExpand: () => 'Развернуто',
  filePicker_addFiles: () => 'Добавить файлы',
  filePicker_dropzonePrimaryText: () => 'Добавьте файлы',
  filePicker_dropzoneSecondaryText: () => 'Выберите или перетащите файл сюда',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Выберите или перетащите файлы сюда',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Невозможна загрузка файлов следующих типов: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Загружайте по одному файлу за один раз',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Загрузка файлов типа ' + p['fileType'] + ' невозможна',
  filePicker_unknownFileTypeUploadError: () => 'неизвестно',
  formControl_clear: () => 'Очистить',
  formControl_day: () => 'День',
  formControl_helpAvailable: () => 'Доступна справка',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Достигнуто ограничение в ' +
    ((
      {
        one: '1 символ',
        few: new Intl.NumberFormat('ru').format(p['CHARACTER_LIMIT']) + ' символа',
        many: new Intl.NumberFormat('ru').format(p['CHARACTER_LIMIT']) + ' символов'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('ru').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('ru').format(p['CHARACTER_LIMIT']) + ' символов') +
    '.',
  formControl_loading: () => 'Загрузка',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Превышена максимальная длина ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Осталось символов: ' + p['CHARACTER_COUNT'] + '.',
  formControl_month: () => 'Месяц',
  formControl_readOnly: () => 'Только для чтения',
  formControl_requiredMessageDetail: () => 'Введите значение.',
  formControl_year: () => 'Год',
  gantt_labelDate: () => 'Дата',
  gantt_labelEnd: () => 'Окончание',
  gantt_labelLabel: () => 'Метка',
  gantt_labelRow: () => 'Строка',
  gantt_labelStart: () => 'Начало',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Соответствующий раздел не найден.',
  indexer_keyboardInstructionText: () => 'Нажмите Enter, чтобы выбрать значение.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'С ' + p['FROM_SECTION'] + ' по ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Дважды коснитесь и удерживайте, чтобы перейти в режим жестов, затем перетащите вверх или вниз, чтобы изменить значение.',
  info: () => 'Информация',
  inputDateMask_date_cleared: () => 'Дата удалена',
  inputDateMask_dayPlaceholder: () => 'дд',
  inputDateMask_empty_segment: () => 'Пусто',
  inputDateMask_monthPlaceholder: () => 'мм',
  inputDateMask_yearPlaceholder: () => 'гггг',
  inputNumber_converterParseError: () => 'Введите число.',
  inputNumber_decrease: () => 'Уменьшить',
  inputNumber_increase: () => 'Увеличить',
  inputPassword_hidden: () => 'Пароль скрыт',
  inputPassword_hide: () => 'Скрыть пароль',
  inputPassword_show: () => 'Показать пароль',
  list_suggestion: () => 'Предложение',
  messageToast_allMessagesClosed: () => 'Все всплывающие сообщения-подсказки закрыты.',
  message_close: () => 'Закрыть',
  message_confirmation: () => 'Завершено',
  message_error: () => 'Ошибка',
  message_info: () => 'Информация',
  message_navigationFromMessagesRegion: () =>
    'Вход в область сообщений. Нажмите F6 для возврата к предыдущему элементу в фокусе.',
  message_navigationToMessagesRegion: () =>
    'Область сообщений содержит новые сообщения. Нажмите F6 для перехода к последней области сообщений.',
  message_warning: () => 'Предупреждение',
  noData_message: () => 'Нет элементов для отображения',
  overflowItemLabel: () => 'Больше вкладок',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'Выполняется',
  radio_helpForRadio: () => 'Справка по переключателю',
  radio_requiredMessageDetail: () => 'Выберите значение.',
  selectMultiple_apply: () => 'Применить',
  selectMultiple_back: () => 'Назад',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Нажмите клавишу Backspace или Delete, чтобы удалить выбранное значение.',
  selectMultiple_selectedValues: () => 'Выбранные значения',
  selectMultiple_showSelectedValues: () => 'Показать только выбранные значения.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Выбрано значений: ' + p['VALUE_COUNT'] + '.',
  select_addToList: () => 'Добавить в список',
  select_addToListAvailable: () => 'Доступно "Добавить в список"',
  select_moreSearchOptions: () => 'Дополнительные параметры поиска',
  select_moreSearchOptionsAvailable: () => 'Доступны дополнительные параметры поиска',
  select_noMatchesFound: () => 'Совпадений не найдено.',
  select_oneMatchFound: () => 'Найдено одно совпадение',
  select_requiredMessageDetail: () => 'Выберите значение.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => 'Найдено совпадений: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Найдено совпадений: ' + p['TOTAL_SIZE'] + ' или более',
  selector_selected: () => 'Флажок установлен',
  selector_unselected: () => 'Флажок не установлен',
  tabBarNavigationList_removeCueText: () => 'Для удаления',
  timeComponent_tooltipZoomIn: () => 'Увеличить',
  timeComponent_tooltipZoomOut: () => 'Уменьшить',
  train_current: () => 'Текущий',
  train_message_type: () => 'Тип сообщения',
  train_not_visited: () => 'Не посещено',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Шаг ' + p['currentStep'] + ' из ' + p['numberOfSteps'],
  train_visited: () => 'Посещено',
  userAssistance_learnMore: () => 'Дополнительные сведения',
  userAssistance_required: () => 'Обязательно',
  viz_drillable: () => 'С возможностью детализации',
  warn: () => 'Предупреждение'
};
export default bundle;
